import { Component, OnInit, ViewChild, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';

import { environment } from '../environments/environment';
import { Catalog, Sector, Shop, IconLink } from './catalog.service';

@Component({
  selector: 'cockehsu-header',
  templateUrl: './cockehsu-header.component.html',
  styleUrls: ['./cockehsu-header.component.css']
})
export class CockehsuHeaderComponent implements OnInit {
  @Input()
  logo: IconLink;
  @Input()
  shop: Shop;
  @Input()
  catalog: Catalog;

  opened: boolean;
  private forceLogoMobile: boolean = false;

  constructor() { }

  ngOnInit() {
    this.forceLogoMobile = environment.forceLogoMobile;
  }

}



// WEBPACK FOOTER //
// ./src/app/cockehsu-header.component.ts